import { useEffect } from 'react'
import packageVersion from '../../package.json'

const useCacheClean = () => {
  useEffect(() => {
    const version = localStorage.getItem('version')
    if (version !== packageVersion.version) {
      if ('caches' in window) {
        caches.keys().then((names) => names.forEach((name) => caches.delete(name)))
        window.location.reload(true)
      }
      localStorage.removeItem('version')
      localStorage.setItem('version', packageVersion.version)
    }
  }, [])
}

export default useCacheClean
